import styled from 'styled-components'
import { colors } from 'client/styles'

export const Error = styled.span`
  color: ${colors.red2};
  display: block;
  font-size: 14px;
  font-weight: 700;
  line-height: 140%;
`
